module.exports = __webpack_public_path__ + "static/img/logo21.6cbe102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo21.png
// module id = 0LlE
// module chunks = 2